import { X } from "lucide-react";

export interface FilterChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

export function FilterChip({
  label,
  active,
  onClick,
}: FilterChipProps): React.JSX.Element {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1.5 rounded-lg text-[11px] font-semibold border transition-all ${
        active
          ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-300"
          : "bg-white/[0.02] border-white/[0.06] text-zinc-500 hover:text-zinc-300"
      }`}
    >
      {label}
    </button>
  );
}

export function FilterGroup({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-[10px] uppercase tracking-wider font-semibold text-zinc-600 mr-1">
        {label}
      </span>
      {children}
    </div>
  );
}

export function ClearFiltersButton({
  onClick,
}: {
  onClick: () => void;
}): React.JSX.Element {
  return (
    <button
      onClick={onClick}
      className="ml-auto inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-[11px] font-semibold text-zinc-400 hover:text-white hover:bg-white/[0.04] transition-all"
    >
      <X className="w-3 h-3" />
      Clear
    </button>
  );
}
